module.exports = __webpack_public_path__ + "static/media/japan-final1.d8c23c21.png";